// extracted by mini-css-extract-plugin
export var border = "SectionVolunteeringRoleLookup-module--border--e916e";
export var bordersection = "SectionVolunteeringRoleLookup-module--bordersection--78cc1";
export var lookupwithctacontainer = "SectionVolunteeringRoleLookup-module--lookupwithctacontainer--ed50b";
export var lookupwithctainner = "SectionVolunteeringRoleLookup-module--lookupwithctainner--ff08a";
export var lookupwithctaouter = "SectionVolunteeringRoleLookup-module--lookupwithctaouter--83b5b";
export var lookupwithctatitle = "SectionVolunteeringRoleLookup-module--lookupwithctatitle--ab19e";
export var title = "SectionVolunteeringRoleLookup-module--title--59978 headings-module--sectionHeading--a8f67";